export default "__VITE_ASSET__dd55bdcf__"